var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 82.5C65.7107 82.5 82.5 65.7107 82.5 45C82.5 24.2893 65.7107 7.5 45 7.5C24.2893 7.5 7.5 24.2893 7.5 45C7.5 65.7107 24.2893 82.5 45 82.5Z",
    fill: "#E71B4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7072 31.1686C36.6555 30.6756 37.8063 30.7296 38.7013 31.3092L56.2013 42.6426C57.0127 43.1681 57.5001 44.0527 57.5001 45C57.5001 45.9474 57.0127 46.832 56.2013 47.3575L38.7013 58.6908C37.8063 59.2705 36.6555 59.3245 35.7072 58.8314C34.7588 58.3384 34.1667 57.3783 34.1667 56.3334V33.6667C34.1667 32.6218 34.7588 31.6617 35.7072 31.1686ZM44.213 48.3108L40.0001 51.0392L49.3253 45L44.213 48.3108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.97ab34bc4c3d67011e1e1231f28ffbfc.svg";
export { ForwardRef as ReactComponent };